// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v3LBXbJpAy6adKMlIgpE {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: var(--campaign-header-gap-expanded);
  line-height: 1;
}
.JarGKrtD6JJ6IA4I8gA3[data-collapsed='true'] {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 0 8px;
}
.JarGKrtD6JJ6IA4I8gA3[data-collapsed='true'][data-has-many='false'] > picture {
  width: var(--campaign-info-elements-collapsed-width-desktop);
  display: flex;
  justify-content: center;
}
.JarGKrtD6JJ6IA4I8gA3[data-collapsed='true'][data-has-many='false'] {
  padding: 0 2px;
}
.JarGKrtD6JJ6IA4I8gA3[data-has-many='false'] {
  gap: 3%;
}
.v3LBXbJpAy6adKMlIgpE[data-collapsed='true'][data-has-many='true'] .JarGKrtD6JJ6IA4I8gA3 {
  justify-content: space-between;
  padding: 0 20px;
}
.kqS6BRGw2s5cvafXjUYs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.c8ZTeJFKOm_Yia_sXojq {
  width: var(--campaign-icon-width-desktop);
  height: var(--campaign-icon-height-desktop);
}
.v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
  height: 100%;
  flex-direction: row;
  gap: var(--campaign-header-gap-collapsed-desktop);
}
.DfsV6H1d8C5qN4Fn2OiA {
  color: var(--campaign-color-text-white);
  text-align: center;
  font-size: var(--campaign-title-font-expanded-desktop);
  font-style: normal;
  font-weight: 450;
  line-height: 1;
  font-family: var(--font-family-secondary, inherit);
}
.OpS53cj0gEOU_IokA7Sg {
  text-transform: uppercase;
  white-space: nowrap;
}
.DfsV6H1d8C5qN4Fn2OiA[data-collapsed='true'] {
  font-size: var(--campaign-title-font-collapsed-desktop);
}
.JNzHAoXBK_GzssEpRHEp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 6px;
}
.JNzHAoXBK_GzssEpRHEp > * {
  animation: uYWxcbRrFcXy22bCEWRi 6s infinite;
  opacity: 0;
  position: absolute;
  width: 100%;
  text-align: center;
}
.JNzHAoXBK_GzssEpRHEp .OpS53cj0gEOU_IokA7Sg {
  text-transform: uppercase;
}
.JNzHAoXBK_GzssEpRHEp > *:nth-child(1) {
  animation-delay: 0s;
  margin-left: 5px;
}
.JNzHAoXBK_GzssEpRHEp > *:nth-child(2) {
  animation-delay: 3s;
}
.qGuiROBV90NF0IenjQ0t {
  width: var(--campaign-separator-width-desktop);
  height: 1.5px;
  background: var(--campaign-gradient-separator);
}
.gkt8ZKd1sWn11AFkr2Xc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gkt8ZKd1sWn11AFkr2Xc[data-has-many='false'] {
  gap: 8px;
}
.gkt8ZKd1sWn11AFkr2Xc[data-collapsed='true'][data-has-many='false'] {
  min-width: 200px;
}
.gkt8ZKd1sWn11AFkr2Xc[data-has-many='false'][data-collapsed='false'][data-view='single'] {
  margin-bottom: 14px;
}
/* Visibility toggles for collapsed/expanded content.
   Elements are always in the DOM to avoid mount/unmount during animation,
   but hidden via display:none so they cost zero layout when inactive. */
.juDKTshRBAvQ2yV3OFbQ {
  display: none;
}
.v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] .juDKTshRBAvQ2yV3OFbQ {
  display: block;
}
/* expandedOnly elements inherit their display from their own class
   (e.g. .separatorAndInfoContainer sets display: flex).
   This rule only hides them when collapsed. */
.v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] .RdPCgaeiExkJURb2ZvVJ {
  display: none;
}
@keyframes uYWxcbRrFcXy22bCEWRi {
  0%,
  45% {
    opacity: 1;
  }
  50%,
  95% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .v3LBXbJpAy6adKMlIgpE {
    gap: var(--campaign-header-gap-expanded-mobile);
  }
  .v3LBXbJpAy6adKMlIgpE[data-has-many='false'] {
    gap: var(--campaign-header-gap-expanded-mobile-has-many-false);
  }
  .kqS6BRGw2s5cvafXjUYs {
    gap: 4px;
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
    height: 100%;
    align-items: center;
    /* padding-bottom: 3px; */
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] .JarGKrtD6JJ6IA4I8gA3 {
    /* gap: 0; */
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] .JarGKrtD6JJ6IA4I8gA3[data-has-many='false'] > picture {
    width: var(--campaign-info-elements-collapsed-width-mobile-has-many-false);
  }
  .c8ZTeJFKOm_Yia_sXojq {
    width: var(--campaign-icon-width-mobile);
    height: var(--campaign-icon-height-mobile);
  }
  .JNzHAoXBK_GzssEpRHEp > * {
    margin-top: 6px;
  }
  .DfsV6H1d8C5qN4Fn2OiA[data-collapsed='true'] {
    font-size: var(--campaign-title-font-collapsed-mobile);
  }
  .qGuiROBV90NF0IenjQ0t {
    width: var(--campaign-separator-width-mobile);
  }
  .gkt8ZKd1sWn11AFkr2Xc[data-has-many='false'][data-collapsed='false'] {
    width: 250px;
  }
  .gkt8ZKd1sWn11AFkr2Xc[data-has-many='false'][data-collapsed='false'][data-view='single'] {
    margin-bottom: 5px;
  }
  /* Collapsed, multiple campaigns — mobile part of the section near the top of this file. */
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'][data-has-many='true'] .JarGKrtD6JJ6IA4I8gA3 {
    padding: 0 12px;
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'][data-has-many='true'] .DfsV6H1d8C5qN4Fn2OiA {
    font-size: var(--campaign-title-font-has-many-collapsed-mobile);
    padding-left: 5px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .DfsV6H1d8C5qN4Fn2OiA {
    font-size: var(--campaign-title-font-expanded-mobile-portrait);
  }
  .DfsV6H1d8C5qN4Fn2OiA[data-collapsed='false'][data-has-many='true'] {
    font-size: var(--campaign-title-font-has-many-expanded-mobile);
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
    gap: var(--campaign-header-gap-collapsed-mobile-portrait);
    justify-content: space-evenly;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .DfsV6H1d8C5qN4Fn2OiA {
    font-size: var(--campaign-title-font-expanded-mobile-portrait);
  }
  .DfsV6H1d8C5qN4Fn2OiA[data-collapsed='false'][data-has-many='true'] {
    font-size: var(--campaign-title-font-has-many-expanded-mobile);
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
    gap: var(--campaign-header-gap-collapsed-mobile-portrait);
    justify-content: space-evenly;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .DfsV6H1d8C5qN4Fn2OiA {
    font-size: var(--campaign-title-font-expanded-mobile-landscape);
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
    gap: var(--campaign-header-gap-collapsed-mobile-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .DfsV6H1d8C5qN4Fn2OiA {
    font-size: var(--campaign-title-font-expanded-mobile-landscape);
  }
  .v3LBXbJpAy6adKMlIgpE[data-collapsed='true'] {
    gap: var(--campaign-header-gap-collapsed-mobile-landscape);
  }
}
}
}
}
@media (max-width: 374px) {
  .gkt8ZKd1sWn11AFkr2Xc[data-collapsed='true'][data-has-many='false'] {
    min-width: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/CampaignCard/CampaignCardStyles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,4DAA4D;EAC5D,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2CAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8CAA8C;EAC9C,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;wEAEwE;AACxE;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;8CAE8C;AAC9C;EACE,aAAa;AACf;AACA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,8DAA8D;EAChE;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,0EAA0E;EAC5E;EACA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;EACA;IACE,eAAe;EACjB;EACA;IACE,sDAAsD;EACxD;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA,0FAA0F;EAC1F;IACE,eAAe;EACjB;EACA;IACE,+DAA+D;IAC/D,iBAAiB;EACnB;AACF;AACA;AAAA;EACE;IACE,8DAA8D;EAChE;EACA;IACE,8DAA8D;EAChE;EACA;IACE,yDAAyD;IACzD,6BAA6B;EAC/B;AACF;AAAA;AAXA;AAAA;AAAA;AAAA;EACE;IACE,8DAA8D;EAChE;EACA;IACE,8DAA8D;EAChE;EACA;IACE,yDAAyD;IACzD,6BAA6B;EAC/B;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,0DAA0D;EAC5D;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,0DAA0D;EAC5D;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".campaignCardContainer {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--campaign-header-gap-expanded);\n  line-height: 1;\n}\n.topHeaderContainerCollapsed[data-collapsed='true'] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding: 0 8px;\n}\n.topHeaderContainerCollapsed[data-collapsed='true'][data-has-many='false'] > picture {\n  width: var(--campaign-info-elements-collapsed-width-desktop);\n  display: flex;\n  justify-content: center;\n}\n.topHeaderContainerCollapsed[data-collapsed='true'][data-has-many='false'] {\n  padding: 0 2px;\n}\n.topHeaderContainerCollapsed[data-has-many='false'] {\n  gap: 3%;\n}\n.campaignCardContainer[data-collapsed='true'][data-has-many='true'] .topHeaderContainerCollapsed {\n  justify-content: space-between;\n  padding: 0 20px;\n}\n.separatorAndInfoContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n.campaignIcon {\n  width: var(--campaign-icon-width-desktop);\n  height: var(--campaign-icon-height-desktop);\n}\n.campaignCardContainer[data-collapsed='true'] {\n  height: 100%;\n  flex-direction: row;\n  gap: var(--campaign-header-gap-collapsed-desktop);\n}\n.campaignTitleContainer {\n  color: var(--campaign-color-text-white);\n  text-align: center;\n  font-size: var(--campaign-title-font-expanded-desktop);\n  font-style: normal;\n  font-weight: 450;\n  line-height: 1;\n  font-family: var(--font-family-secondary, inherit);\n}\n.campaignNameText {\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.campaignTitleContainer[data-collapsed='true'] {\n  font-size: var(--campaign-title-font-collapsed-desktop);\n}\n.campaignTitleCollapsed {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n.campaignTitleCollapsed > * {\n  animation: textCycle 6s infinite;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n}\n.campaignTitleCollapsed .campaignNameText {\n  text-transform: uppercase;\n}\n.campaignTitleCollapsed > *:nth-child(1) {\n  animation-delay: 0s;\n  margin-left: 5px;\n}\n.campaignTitleCollapsed > *:nth-child(2) {\n  animation-delay: 3s;\n}\n.separator {\n  width: var(--campaign-separator-width-desktop);\n  height: 1.5px;\n  background: var(--campaign-gradient-separator);\n}\n.namePrizeWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.namePrizeWrapper[data-has-many='false'] {\n  gap: 8px;\n}\n.namePrizeWrapper[data-collapsed='true'][data-has-many='false'] {\n  min-width: 200px;\n}\n.namePrizeWrapper[data-has-many='false'][data-collapsed='false'][data-view='single'] {\n  margin-bottom: 14px;\n}\n/* Visibility toggles for collapsed/expanded content.\n   Elements are always in the DOM to avoid mount/unmount during animation,\n   but hidden via display:none so they cost zero layout when inactive. */\n.collapsedOnly {\n  display: none;\n}\n.campaignCardContainer[data-collapsed='true'] .collapsedOnly {\n  display: block;\n}\n/* expandedOnly elements inherit their display from their own class\n   (e.g. .separatorAndInfoContainer sets display: flex).\n   This rule only hides them when collapsed. */\n.campaignCardContainer[data-collapsed='true'] .expandedOnly {\n  display: none;\n}\n@keyframes textCycle {\n  0%,\n  45% {\n    opacity: 1;\n  }\n  50%,\n  95% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@media (--campaign-mobile) {\n  .campaignCardContainer {\n    gap: var(--campaign-header-gap-expanded-mobile);\n  }\n  .campaignCardContainer[data-has-many='false'] {\n    gap: var(--campaign-header-gap-expanded-mobile-has-many-false);\n  }\n  .separatorAndInfoContainer {\n    gap: 4px;\n  }\n  .campaignCardContainer[data-collapsed='true'] {\n    height: 100%;\n    align-items: center;\n    /* padding-bottom: 3px; */\n  }\n  .campaignCardContainer[data-collapsed='true'] .topHeaderContainerCollapsed {\n    /* gap: 0; */\n  }\n  .campaignCardContainer[data-collapsed='true'] .topHeaderContainerCollapsed[data-has-many='false'] > picture {\n    width: var(--campaign-info-elements-collapsed-width-mobile-has-many-false);\n  }\n  .campaignIcon {\n    width: var(--campaign-icon-width-mobile);\n    height: var(--campaign-icon-height-mobile);\n  }\n  .campaignTitleCollapsed > * {\n    margin-top: 6px;\n  }\n  .campaignTitleContainer[data-collapsed='true'] {\n    font-size: var(--campaign-title-font-collapsed-mobile);\n  }\n  .separator {\n    width: var(--campaign-separator-width-mobile);\n  }\n  .namePrizeWrapper[data-has-many='false'][data-collapsed='false'] {\n    width: 250px;\n  }\n  .namePrizeWrapper[data-has-many='false'][data-collapsed='false'][data-view='single'] {\n    margin-bottom: 5px;\n  }\n  /* Collapsed, multiple campaigns — mobile part of the section near the top of this file. */\n  .campaignCardContainer[data-collapsed='true'][data-has-many='true'] .topHeaderContainerCollapsed {\n    padding: 0 12px;\n  }\n  .campaignCardContainer[data-collapsed='true'][data-has-many='true'] .campaignTitleContainer {\n    font-size: var(--campaign-title-font-has-many-collapsed-mobile);\n    padding-left: 5px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .campaignTitleContainer {\n    font-size: var(--campaign-title-font-expanded-mobile-portrait);\n  }\n  .campaignTitleContainer[data-collapsed='false'][data-has-many='true'] {\n    font-size: var(--campaign-title-font-has-many-expanded-mobile);\n  }\n  .campaignCardContainer[data-collapsed='true'] {\n    gap: var(--campaign-header-gap-collapsed-mobile-portrait);\n    justify-content: space-evenly;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .campaignTitleContainer {\n    font-size: var(--campaign-title-font-expanded-mobile-landscape);\n  }\n  .campaignCardContainer[data-collapsed='true'] {\n    gap: var(--campaign-header-gap-collapsed-mobile-landscape);\n  }\n}\n@media (max-width: 374px) {\n  .namePrizeWrapper[data-collapsed='true'][data-has-many='false'] {\n    min-width: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignCardContainer": `v3LBXbJpAy6adKMlIgpE`,
	"topHeaderContainerCollapsed": `JarGKrtD6JJ6IA4I8gA3`,
	"separatorAndInfoContainer": `kqS6BRGw2s5cvafXjUYs`,
	"campaignIcon": `c8ZTeJFKOm_Yia_sXojq`,
	"campaignTitleContainer": `DfsV6H1d8C5qN4Fn2OiA`,
	"campaignNameText": `OpS53cj0gEOU_IokA7Sg`,
	"campaignTitleCollapsed": `JNzHAoXBK_GzssEpRHEp`,
	"textCycle": `uYWxcbRrFcXy22bCEWRi`,
	"separator": `qGuiROBV90NF0IenjQ0t`,
	"namePrizeWrapper": `gkt8ZKd1sWn11AFkr2Xc`,
	"collapsedOnly": `juDKTshRBAvQ2yV3OFbQ`,
	"expandedOnly": `RdPCgaeiExkJURb2ZvVJ`
};
export default ___CSS_LOADER_EXPORT___;
